const MethodicEnum = Object.freeze({
  META_VALUES: 1,
  PSYHO_DISTRESS: 2,
  SATISFACTION: 3,
  WELL_BEING: 4
});

export default (MethodicEnum);
